<template>
  <div>
    <b-modal
      id="false-alert-confirmation"
      :title="$t('notification.text.markFalseAlert') + '?'"
      size="md"
      centered
    >
      <div>
        {{ $t('notification.action.willBeMarked') }}
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex justify-content-end">
          <McButton
            :text="$t('global.cancel')"
            size="md"
            variant="outline-primary"
            @click="cancel()"
          />
          <McButton
            :text="$t('notification.action.falseAlertConfirmation')"
            size="md"
            class="ms-2"
            variant="primary"
            @click="handleSubmit"
          />
        </div>
      </template>
    </b-modal>
    <b-modal
      id="recheck-confirmation"
      :title="$t('notification.action.revertTitle') + '?'"
      size="md"
      centered
    >
      <span v-html="$t('notification.action.recheckQuestion')" />
      <template #modal-footer="{ cancel }">
        <div class="d-flex justify-content-end">
          <McButton
            :text="$t('global.cancel')"
            size="md"
            variant="outline-primary"
            @click="cancel()"
          />
          <McButton
            :text="$t('notification.action.yes')"
            size="md"
            class="ms-2"
            variant="primary"
            @click="handleSubmitRecheck"
          />
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-delete-notes"
      :title="$t('notification.action.clearNotes') + '?'"
      size="md"
      centered
    >
      <div>
        {{ $t('notification.action.deletedNotesCantBeRetrieved') }}
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex justify-content-end">
          <McButton
            :text="$t('global.cancel')"
            size="md"
            variant="outline-primary"
            @click="cancel()"
          />
          <McButton
            :text="`${$t('global.yes')}, ${$t('global.delete')}`"
            size="md"
            class="ms-2"
            variant="primary"
            @click="handleSubmitDelete"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },

  methods: {
    handleSubmit() {
      this.$emit('submit')
    },

    handleSubmitRecheck() {
      this.$emit('submitRecheck')
    },

    handleSubmitDelete() {
      this.$emit('submitDelete')
    },
  },
}
</script>
